export enum CommunitiesDetailsRoute {
    Statistics = 'statistics',
    Settings = 'settings',
    History = 'history'
}
